export const WAITING_LIST_ENDPOINT = `${process.env.GATSBY_BASE_URL}/waitinglist`
export const WAITING_LIST_MESSAGE =
  'See you soon. You’re one step closer to effortless investing!'
